import axios from 'axios'
const config = require("../configuration/");
const API_BASE_URL = (`${window.location.pathname}` === '/usuarios')  ? config.API_SSO : config.API_BASE_URL_NESTJS;

const apiBase = axios.create({
    baseURL: API_BASE_URL
});

export default apiBase;